import {postMethod, putMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/prepareBookTour', request)
}

async function put(basketKey, request) {
    return await putMethod(`/api/prepareBookTour/${basketKey}`, request)
}

export {post, put}
